import { email } from '@/utils/rules/customRules';

export const commonValidateEmail = ({ mail, isRequired = false }) => {
    if (mail === undefined) return;
    let msg = '';
    if (!isRequired && mail === '') {
        msg = '';
    } else if (mail === '') {
        msg = '請輸入E-mail';
    } else {
        msg = email(mail) || '';
    }
    return msg;
};
